import { render, staticRenderFns } from "./NotificationDetail.vue?vue&type=template&id=24cb4b11"
import script from "./NotificationDetail.vue?vue&type=script&lang=ts"
export * from "./NotificationDetail.vue?vue&type=script&lang=ts"
import style0 from "./NotificationDetail.vue?vue&type=style&index=0&id=24cb4b11&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports